<template>
  <div class="detail-container">
    <el-button @click="$router.back()">返回商品列表</el-button>
    <el-card v-loading="loading" :loading-text="'加载中...'">
      <el-descriptions column="1" border>
        <el-descriptions-item label="商品 ID">{{ merchandise.merchandise_id }}</el-descriptions-item>
        <el-descriptions-item label="商品名称">{{ merchandise.name }}</el-descriptions-item>
        <el-descriptions-item label="商品规格">{{ merchandise.specification || '无' }}</el-descriptions-item>
        <el-descriptions-item label="商品分类">{{ merchandise.category || '无' }}</el-descriptions-item>
      </el-descriptions>
      <div style="text-align: right; margin-top: 20px;">
        <el-button type="primary" @click="openEditDialog">编辑商品</el-button>
        <el-button type="danger" @click="handleDelete">删除商品</el-button>
      </div>
    </el-card>

    <!-- 编辑商品弹窗 -->
    <el-dialog title="编辑商品" v-model="editDialogVisible" width="400px">
      <el-form :model="editForm" ref="editForm" :rules="rules" label-width="80px">
        <el-form-item label="商品名称" prop="name">
          <el-input v-model="editForm.name"></el-input>
        </el-form-item>
        <el-form-item label="商品规格" prop="specification">
          <el-input v-model="editForm.specification"></el-input>
        </el-form-item>
        <el-form-item label="商品分类" prop="category">
          <el-input v-model="editForm.category"></el-input>
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button @click="editDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="submitEdit">保存</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import merchandiseAPI from '@/api/merchandises';

export default {
  props: {
    id: {
      type: [Number, String],
      required: true,
    },
  },
  data() {
    return {
      merchandise: {},
      loading: false,
      editDialogVisible: false,
      editForm: {
        name: '',
        specification: '',
        category: '',
      },
      rules: {
        name: [
          { required: true, message: '请输入商品名称', trigger: 'blur' },
        ],
      },
    };
  },
  created() {
    this.fetchMerchandiseDetail();
  },
  methods: {
    async fetchMerchandiseDetail() {
      this.loading = true;
      try {
        const res = await merchandiseAPI.inquireMerchandise(this.id);
        this.merchandise = res;
        this.editForm = {
          name: this.merchandise.name,
          specification: this.merchandise.specification,
          category: this.merchandise.category,
        };
      } catch (error) {
        console.error('获取商品详情失败：', error);
        this.$message.error(error.message || '加载商品详情失败，请重试');
      } finally {
        this.loading = false;
      }
    },
    openEditDialog() {
      this.editDialogVisible = true;
    },
    async submitEdit() {
      this.$refs.editForm.validate(async (valid) => {
        if (valid) {
          try {
            await merchandiseAPI.updateMerchandise(this.id, this.editForm);
            this.$message.success('商品编辑成功');
            this.editDialogVisible = false;
            this.fetchMerchandiseDetail();
          } catch (error) {
            console.error('编辑商品失败：', error);
            this.$message.error(error.message || '编辑商品失败，请重试');
          }
        }
      });
    },
    async handleDelete() {
      try {
        await this.$confirm('确定删除该商品吗？删除后数据不可恢复！', '警告', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        });
        await merchandiseAPI.deleteMerchandise(this.id);
        this.$message.success('商品删除成功');
        this.$router.push('/merchandises');
      } catch (error) {
        if (error === 'cancel' || error.name === 'CanceledError') {
          this.$message.info('已取消删除');
        } else {
          console.error('删除商品失败：', error);
          this.$message.error(error.message || '删除商品失败，请重试');
        }
      }
    },
  },
};
</script>

<style scoped>
.detail-container {
  padding: 20px;
  animation: fadeIn 0.3s ease;
}
.el-button:first-child {
  margin-bottom: 20px;
}
.el-descriptions {
  border-radius: 16px;
  overflow: hidden;
}
.el-descriptions__title {
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 16px;
  background: linear-gradient(135deg, #1e293b, #3b82f6);
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
  display: inline-block;
}
.el-descriptions__label {
  font-weight: 600;
  background-color: #f8fafc;
  width: 120px;
}
.el-descriptions__content {
  background-color: white;
}
.detail-container .el-card__body > div:last-child {
  margin-top: 24px;
  text-align: right;
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  flex-wrap: wrap;
}
@media (max-width: 768px) {
  .detail-container {
    padding: 12px !important;
  }
  .el-descriptions {
    font-size: 12px;
  }
  .el-descriptions__label {
    width: 80px !important;
  }
  .el-descriptions__content {
    word-break: break-all;
  }
  .detail-container .el-card__body > div:last-child {
    flex-direction: column;
    align-items: stretch;
  }
  .el-button {
    width: 100%;
    margin: 0 !important;
  }
}
@keyframes fadeIn {
  from { opacity: 0; transform: translateY(10px); }
  to { opacity: 1; transform: translateY(0); }
}
</style>